import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import useSectionDarkMode from "../../hooks/useSectionDarkMode";
import { IOSSwitch } from "../common/IOSSwitch";

const CookiePreferencesModal = ({
  open,
  onClose,
  preferences,
  onSave,
}) => {
  const { t } = useTranslation();
  const darkMode = useSectionDarkMode("bottom");

  // Draft cục bộ: Cancel/Đóng không ghi cookie, chỉ Lưu mới commit
  const [draft, setDraft] = useState(preferences);

  useEffect(() => {
    if (!open) return;
    setDraft({
      functional: preferences?.functional === true,
      analytics: preferences?.analytics === true,
      marketing: preferences?.marketing === true,
    });
  }, [open, preferences]);

  useEffect(() => {
    if (!open) return;
    const original = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = original;
    };
  }, [open]);

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[1000] flex items-center justify-center px-4">
      <div
        className="absolute inset-0 bg-black/40 backdrop-blur-md"
        onClick={onClose}
      />

      <div
        className={`
    relative w-full max-w-[60vw] mobile:max-w-[80vw] 
    rounded-2xl border border-white/10 shadow-2xl
    backdrop-blur-[30px]
    ${darkMode ? "bg-neutral-13/80 text-white" : "bg-white/70 text-neutral-13"}
    max-h-[calc(100vh-2rem)] flex flex-col mobile:max-h-[80vh]
  `}
      >
        <div
          className={`flex items-center justify-between  px-6 py-4 
                    ${
                      darkMode
                        ? "border-b border-neutral-1"
                        : "border-b border-neutral-13"
                    }`}
        >
          <h2 className="text-[18px] font-bold">
            {t("cookies.preferencesTitle")}
          </h2>
          <button
            onClick={onClose}
            className="text-xl hover:opacity-70 transition"
          >
            ×
          </button>
        </div>

        <div
          className="
  px-6 py-5 space-y-6 text-sm
  flex-1 overflow-y-auto
  overscroll-contain
"
        >
          <div className="flex justify-between gap-6 items-center">
            <div>
              <p className="text-[16px] font-bold">
                {t("cookies.strictlyNecessary")}
              </p>
              <p className="mt-1 opacity-80">
                {t("cookies.strictlyNecessaryDesc")}
              </p>
            </div>
            <span className="text-brandBlue-500 text-[16px] font-semibold whitespace-nowrap">
              {t("cookies.alwaysActive")}
            </span>
          </div>

          <Row
            label={t("cookies.functional")}
            desc={t("cookies.functionalDesc")}
          >
            <IOSSwitch
              checked={draft.functional}
              onChange={(e) =>
                setDraft((p) => ({
                  ...p,
                  functional: e.target.checked,
                }))
              }
            />
          </Row>

          <Row
            label={t("cookies.analytics")}
            desc={t("cookies.analyticsDesc")}
          >
            <IOSSwitch
              checked={draft.analytics}
              onChange={(e) =>
                setDraft((p) => ({
                  ...p,
                  analytics: e.target.checked,
                }))
              }
            />
          </Row>

          <Row
            label={t("cookies.marketing")}
            desc={t("cookies.marketingDesc")}
          >
            <IOSSwitch
              checked={draft.marketing}
              onChange={(e) =>
                setDraft((p) => ({
                  ...p,
                  marketing: e.target.checked,
                }))
              }
            />
          </Row>
        </div>

        <div
          className={`flex justify-end gap-2 px-6 py-4 
                    ${
                      darkMode
                        ? "border-t border-neutral-1"
                        : "border-t border-neutral-13"
                    }`}
        >
          <button
            onClick={onClose}
            className={`px-[10px] py-[10px] text-[15px] rounded-md hover:bg-white/10 h-[48px]  ${
              darkMode
                ? "text-brandBlue-500 bg-white hover:bg-white/80"
                : "text-neutral-13 bg-white hover:bg-white/80"
            }`}
          >
            {t("cookies.cancel")}
          </button>

          <button
            onClick={() => {
              onSave?.(draft);
            }}
            className="px-[10px] py-[10px] text-[15px] h-[48px] rounded-md font-medium
             bg-brandBlue-500 hover:bg-brandBlue-600 text-white"
          >
            {t("cookies.savePreferences")}
          </button>
        </div>
      </div>
    </div>
  );
};

const Row = ({ label, desc, children }) => (
  <div className="flex items-center gap-4">
    <div className="flex-1 max-w-100%]">
      <p className="text-[16px] font-bold leading-snug">{label}</p>
      <p className="mt-1 text-[15px] opacity-80 leading-snug">{desc}</p>
    </div>
    <div className="shrink-0 pt-1">{children}</div>
  </div>
);

export default CookiePreferencesModal;
